import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
} from "../../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
} from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import {
  addNewAgentApplication,
  setCurrentAgentMortgageProperty,
} from "../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";
import TopNavigationBar from "../../TopNavigationBar";

const MORTGAGE_APPLICATION_ASSOCIATE = "BeforeYouStart";

const applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;
const applicationMode = APPLICATION_MODE_NEW;

export const BeforeYouStart = (props) => {
  const dispatch = useDispatch();
  const [ageConfirmCheck, setAgeConfirmCheck] = useState(false);
  const [authorityConfirmCheck, setAuthorityConfirmCheck] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails
  );

  const principalBrokerSelect = useSelector((state) => ({
    primaryAgencyApplicationId: state.primaryAgencyApplication?.application?.id,
    companyRjscDetails:
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails,
    companyTrademark:
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyTrademark,
  }));

  const { primaryAgencyApplicationId, companyTrademark } =
    principalBrokerSelect;

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar 
            {...props} 
            applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE} 
            applicationMode={APPLICATION_MODE_NEW} 
        />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              id="before-you-start-header"
              header="Before you start the application"
            />
            <div style={{ marginBottom: "35px" }}>
              <Paragraph
                style={{ margin: "0 0 0 0" }}
                id="before-you-start-text"
                text={[
                  "Make sure you have the applicant's:",
                  "- full name, civic address, phone number and email",
                  "- criminal record check",
                  "- proof of completing the Nova Scotia Broker Education Program or Nova Scotia Associate Broker Course, if not currently licensed in another province.",
                ]}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-before-start-applicant-age-checkbox"
              checked={ageConfirmCheck}
              value={ageConfirmCheck}
              labelText="Confirm the applicant is at least 19 years old"
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setAgeConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-before-start-principal-authority-checkbox"
              checked={authorityConfirmCheck}
              value={authorityConfirmCheck}
              labelText="Confirm that the principal broker has the authority to licence this individual on behalf of the agency"
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setAuthorityConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Continue"}
              onClick={() => {
                if (!ageConfirmCheck || !authorityConfirmCheck) {
                  setShowValidationError(true);
                  return;
                }

                setShowValidationError(false);

                // Create a new agent app
                dispatch(
                  addNewAgentApplication({
                    agentLicenceSubType:
                      LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
                    businessApplicationId: primaryAgencyApplicationId,
                    businessName:
                      companyRjscDetails.businessEntity.businessName,
                    companyRjscDetails,
                    companyTrademark: companyTrademark
                      ? companyTrademark
                      : null,
                  })
                );

                // Set MORTGAGE PROP value
                dispatch(
                  setCurrentAgentMortgageProperty({
                    key: MORTGAGE_APPLICATION_ASSOCIATE,
                    value: true,
                  })
                );

                // On to the next item
                dispatch(
                  saveBusinessLicenceApplicationData(
                    applicationType,
                    applicationMode
                  )
                )
                  .then((data) => {
                    dispatch(
                      push({
                        pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_CURRENTLY_BROKER_IN_NS}`,
                        state: { MRA_BROKER_ASSOCIATE: true },
                      })
                    );
                  })
                  .catch((err) => {
                    setApplicationSaveError(true);
                  });
              }}
            />
            {(showValidationError || applicationSaveError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
